<label [ngClass]="{'required': field.required}" *ngIf="!field.arrayChild">
  {{labelVisible ? label : ''}}
</label>

<span [ngSwitch]="field.type" [formGroup]="form">
  <ng-template [ngSwitchCase]="'hidden'">
    <input type="hidden" [formControlName]="fieldName"/>
  </ng-template>
  <ng-template [ngSwitchCase]="'text'" ngSwitchDefault>
    <input type="text" [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly"/>
  </ng-template>
  <ng-template [ngSwitchCase]="'carrier_details'" ngSwitchDefault>
    <input type="text" [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly" [pattern]='"^[A-Z]+(_[A-Z0-9]+)*$"'/>
  </ng-template>
  <ng-template [ngSwitchCase]="'long-text'">
    <textarea [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly"></textarea>
  </ng-template>
  <ng-template [ngSwitchCase]="'object'">
    <textarea [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly"></textarea>
  </ng-template>
    <ng-template [ngSwitchCase]="'password'">
    <input type="password" [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly"/>
  </ng-template>
  <ng-template [ngSwitchCase]="'integer'">
    <input type="number" [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly"/>
  </ng-template>
  <ng-template [ngSwitchCase]="'number'">
    <input type="number" [placeholder]="placeholder" [formControlName]="fieldName" step="any" [required]="field.required" [readOnly]="field.readonly"/>
  </ng-template>
  <ng-template [ngSwitchCase]="'email'">
    <input type="email" [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly"/>
  </ng-template>
  <ng-template [ngSwitchCase]="'color'">
    <input type="color" [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly"/>
  </ng-template>
  <ng-template [ngSwitchCase]="'file'">
    <input type="file" [placeholder]="placeholder" [formControlName]="fieldName" [required]="field.required" [readOnly]="field.readonly" [accept]="field.accept"/>
  </ng-template>
  <ng-template [ngSwitchCase]="'select'">
    <select [formControlName]="fieldName" [required]="field.required">
      <option value="">-- Select --</option>
      <option *ngFor="let option of combinedOptions" value="{{formatSelectOption(option).value}}">{{formatSelectOption(option).display}}</option>
    </select>
  </ng-template>
  <ng-template [ngSwitchCase]="'note'">
    <div class="input-note">{{field.note}}</div>
  </ng-template>
  <ng-template [ngSwitchCase]="'boolean'">
    <label class="pure-checkbox">
      <input type="checkbox" [formControlName]="fieldName" [readOnly]="field.readonly"/>
      {{label}}
    </label>
  </ng-template>
  <ng-template [ngSwitchCase]="'array'">
    <array-input [field]="field" [form]="form" [requestHeaders]="requestHeaders" [workingRowData]="workingRowData" [methodDataPath]="methodDataPath"></array-input>
  </ng-template>
</span>
